import { Disclosure } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import { flexRender, HeaderGroup, Row } from "@tanstack/react-table"
import { Img } from "../../image"

interface ExpandableProps {
    row: Row<any>
    viewOptions: any
    getHeaderGroups: HeaderGroup<any>[]
}
export const Expandable: React.FC<ExpandableProps> = ({ row, viewOptions, getHeaderGroups }) => {
    let rowVals = row._getAllCellsByColumnId()
    return (
        <div className="mb-2 rounded-md border items-start bg-white dark:bg-slate-700 text-black dark:text-white dark:border-slate-600">
            <Disclosure >
                {({ open, close }) => (
                    <div>
                        <Disclosure.Button className={`flex w-full items-center`}>
                            {rowVals['image'] && <div className="p-2">
                                {flexRender(rowVals['image']?.column?.columnDef?.cell, rowVals['image']?.getContext())}
                            </div>}
                            <div className="text-left box-border h-full p-2 w-4/5" >
                                <h4 className="font-semibold">{row.original[viewOptions?.mainTitle.accessKey]}</h4>
                                <div className="text-xs">
                                    {
                                        viewOptions?.subElements?.map((element: any, index: number) => (
                                            <p className="my-1" key={index}>
                                                {element.label && <span className="font-semibold">{element.label}: </span>} {element.renderFn ? element.renderFn(row) : row.original[element.accessorKey]}
                                            </p>
                                        ))
                                    }
                                </div>
                            </div>
                            <ChevronDownIcon className="h-5 w-5 my-auto ml-auto mr-3"></ChevronDownIcon>
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm border-l border-r border-blue-100 dark:border-slate-600 rounded-b-md">
                            <table className="w-full">
                                {
                                    getHeaderGroups.map((group, index) => (
                                        <div className="w-full" key={index}>
                                            {group.headers.map((header, index2) => {
                                                return header.id !== 'select' &&
                                                    <tr className=" border-b dark:border-slate-500 border-slate-300 w-full" key={index2}>
                                                        <td className="  p-3 align-top w-1/2 font-semibold">
                                                                {flexRender(header.column.columnDef.header, header.getContext())} :
                                                            {/* <div className="flex border box-border items-center border-slate-400 p-2" key={header.id}>
                                                            </div> */}
                                                        </td>

                                                        <td className="  p-3 align-top  w-1/2">
                                                            {flexRender(rowVals[header.id].column.columnDef.cell, rowVals[header.id].getContext())}
                                                            {/* <div className='flex items-center border-slate-400 p-2 box-border'>
                                                            </div> */}
                                                        </td>
                                                    </tr>
                                            }
                                            )}
                                        </div>
                                    ))
                                }
                            </table>
                        </Disclosure.Panel>
                    </div>
                )}
            </Disclosure>
        </div>
    )
}